/**
 * Emotion Hotfix - Simple override for theme attachment issues
 */

/**
 * Initialize aggressive emotion patches
 */
export const initEmotionHotfix = () => {
  if (typeof window === 'undefined') return;

  // Patch 1: Override console.error to catch and handle theme errors
  const originalError = console.error;
  console.error = function (...args) {
    const errorMessage = args.join(' ');
    if (errorMessage.includes('Cannot assign to read only property') && errorMessage.includes('theme')) {
      console.warn('Theme mutation error suppressed:', errorMessage);
      return; // Don't log the error
    }
    originalError.apply(console, args);
  };

  // Patch 2: Global error handler for runtime errors
  window.addEventListener('error', (event) => {
    if (
      event.error &&
      event.error.message &&
      event.error.message.includes('Cannot assign to read only property') &&
      event.error.message.includes('theme')
    ) {
      console.warn('Theme mutation error caught:', event.error.message);
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    return true;
  });

  // Patch 3: Unhandled promise rejection handler
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason &&
      event.reason.message &&
      event.reason.message.includes('Cannot assign to read only property') &&
      event.reason.message.includes('theme')
    ) {
      console.warn('Theme mutation promise rejection caught:', event.reason.message);
      event.preventDefault();
      return false;
    }
    return true;
  });

  console.log('🔧 Emotion hotfix applied');
};

export default initEmotionHotfix;
